var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import colors from '../../themes/colors';
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n  z-index: 0;\n  border-radius: 4px;\n\n  &:hover {\n    opacity: 0.08;\n  }\n\n  &:active {\n    opacity: 0.2;\n  }\n\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n  z-index: 0;\n  border-radius: 4px;\n\n  &:hover {\n    opacity: 0.08;\n  }\n\n  &:active {\n    opacity: 0.2;\n  }\n\n  ", "\n"])), function (_a) {
    var opposite = _a.opposite;
    if (opposite)
        return "background-color: ".concat(colors.neutral0, ";");
    return "background-color: ".concat(colors.neutral80, ";");
});
export default Overlay;
var templateObject_1;
